import Platform from '../../../exports/Platform';
export default Platform;


// WEBPACK FOOTER //
// ./node_modules/react-native-web/dist/vendor/react-native/Utilities/Platform.js